<div class="container">
  <h1>{{'footer.faq' | translate}}</h1>
  <div class="widget-accordion py-3">
    <div id="accordion" class="accordion">
      <div class="card" *ngFor="let item of results; let i=index">
        <div class="card-header">
          <a class="card-link collapsed" data-toggle="collapse" href="{{'#collapse'+i}}" aria-expanded="false">
            {{getTranslationText(item.question)}} </a>
        </div>
        <div id="{{'collapse'+i}}" class="collapse" data-parent="#accordion">
          <div class="card-body" [innerHTML]="getAnswerHtml(item.answer)"> </div>
        </div>
      </div>
    </div>
  </div>
</div>
